function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { scheduleStoreApi, scheduleTypesApi, scheduleEditApi, scheduleInfoApi } from '@/api/user';
export default {
  name: '',
  components: {
    ueditorFrom: function ueditorFrom() {
      return import('@/components/form-common/oa-wangeditor');
    },
    selectMember: function selectMember() {
      return import('@/components/form-common/select-member');
    }
  },
  props: ['leftTime'],
  data: function data() {
    var _this = this;
    var checkMember = function checkMember(rule, value, callback) {
      if (_this.superiorUser.length == 0) {
        return callback(new Error('请选择参与人'));
      } else {
        return callback();
      }
    };
    var checkDays = function checkDays(rule, value, callback) {
      if (_this.ruleForm.days.length == 0) {
        return callback(new Error('请选择重复日期'));
      } else {
        return callback();
      }
    };
    return {
      edit: false,
      title: '选择成员',
      loading: false,
      cidName: '',
      superiorUser: [],
      // 参与人
      id: '',
      // 日程id
      drawer: false,
      startDate: '',
      startTime: '',
      endDate: '',
      endTime: '',
      backgroundColor: '#1890FF',
      tableData: [],
      durationType: 2,
      durationList: [{
        value: 1,
        label: '30分钟'
      }, {
        value: 2,
        label: '1小时'
      }, {
        value: 3,
        label: '2小时'
      }, {
        value: 4,
        label: '3小时'
      }, {
        value: 5,
        label: '自定义结束时间'
      }],
      week: [{
        value: '1',
        label: this.$t('hr.monday')
      }, {
        value: '2',
        label: this.$t('hr.tuesday')
      }, {
        value: '3',
        label: this.$t('hr.wednesday')
      }, {
        value: '4',
        label: this.$t('hr.thursday')
      }, {
        value: '5',
        label: this.$t('hr.friday')
      }, {
        value: '6',
        label: this.$t('hr.saturday')
      }, {
        value: '7',
        label: this.$t('hr.sunday')
      }],
      ruleForm: {
        title: '',
        member: [],
        content: '',
        remind: 1,
        period: 0,
        all_day: false,
        cid: 1,
        rate: 1,
        // 重复频率
        days: [],
        start_time: '',
        end_time: '',
        fail_time: '',
        type: '',
        // 编辑
        start: '',
        end: ''
      },
      rules: {
        title: [{
          required: true,
          message: '请输入待办标题',
          trigger: 'change'
        }],
        member: [{
          required: true,
          validator: checkMember,
          trigger: ['blur', 'change']
        }],
        days: [{
          required: true,
          validator: checkDays,
          trigger: 'blur'
        }],
        remind: [{
          required: true,
          message: '请选择提醒时间',
          trigger: 'blur'
        }],
        period: [{
          required: true,
          message: '请选择重复频率',
          trigger: 'blur'
        }],
        start_time: [{
          required: true,
          message: '请选择开始时间',
          trigger: 'blur'
        }],
        end_time: [{
          required: true,
          message: '请选择结束时间',
          trigger: 'blur'
        }],
        cid: [{
          required: true,
          message: '请选择日程类型',
          trigger: 'change'
        }],
        rate: [{
          required: true,
          message: '请输入频率',
          trigger: 'blur'
        }]
      },
      repeatOptions: [{
        value: 0,
        label: '不重复'
      }, {
        value: 1,
        label: '按天重复'
      }, {
        value: 2,
        label: '按周重复'
      }, {
        value: 3,
        label: '按月重复'
      }, {
        value: 4,
        label: '按年重复'
      }],
      options: [{
        value: -1,
        label: '不提醒'
      }, {
        value: 0,
        label: '任务开始时'
      }, {
        value: 1,
        label: '提前5分钟'
      }, {
        value: 2,
        label: '提前15分钟'
      }, {
        value: 3,
        label: '提前30分钟'
      }, {
        value: 4,
        label: '提前1小时'
      }, {
        value: 5,
        label: '提前2小时'
      }, {
        value: 6,
        label: '提前1天'
      }, {
        value: 7,
        label: '提前2天'
      }, {
        value: 8,
        label: '提前1周'
      }]
    };
  },
  methods: {
    formatTime: function formatTime() {
      console.log(this.leftTime, 'leftTime');
      if (this.leftTime) {
        this.startDate = this.$moment(this.leftTime).format('yyyy-MM-DD ') || this.$moment().format('yyyy-MM-DD ');
        this.endDate = this.$moment(this.leftTime).format('yyyy-MM-DD ');
      } else {
        this.startDate = this.$moment().format('yyyy-MM-DD ') || this.$moment().format('yyyy-MM-DD ');
        this.endDate = this.$moment().format('yyyy-MM-DD ');
      }
      this.startTime = this.$moment().format('HH:mm:ss');
      this.endTime = this.$moment().add(1, 'hours').format('HH:mm:ss');
    },
    durationTypeFn: function durationTypeFn() {
      var time = this.$moment(this.startDate).format('YYYY-MM-DD ') + this.startTime;
      if (this.durationType == 1) {
        this.ruleForm.end_time = this.$moment(time).add(30, 'minutes').format('YYYY-MM-DD HH:mm:ss');
      } else if (this.durationType == 2) {
        this.ruleForm.end_time = this.$moment(time).add(1, 'hours').format('YYYY-MM-DD HH:mm:ss');
      } else if (this.durationType == 3) {
        this.ruleForm.end_time = this.$moment(time).add(2, 'hours').format('YYYY-MM-DD HH:mm:ss');
      } else if (this.durationType == 4) {
        this.ruleForm.end_time = this.$moment(time).add(3, 'hours').format('YYYY-MM-DD HH:mm:ss');
      } else if (this.durationType == 5) {
        this.ruleForm.end_time = this.$moment(this.endDate + ' ' + this.endTime).format('YYYY-MM-DD HH:mm:ss');
      }
    },
    submitForm: function submitForm() {
      var _this2 = this;
      this.durationTypeFn();
      this.ruleForm.member = [];
      if (this.ruleForm.all_day) {
        this.ruleForm.all_day = 1;
        this.ruleForm.start_time = this.$moment(this.startDate).format('YYYY-MM-DD ') + '00:00:00';
        this.ruleForm.end_time = this.$moment(this.endDate).format('YYYY-MM-DD ') + '23:59:59';
      } else {
        this.ruleForm.all_day = 0;
        if (this.startDate && this.startTime) {
          this.ruleForm.start_time = this.$moment(this.startDate).format('YYYY-MM-DD ') + this.startTime;
        }
        if (this.edit) {
          if (this.endDate && this.endTime) {
            this.ruleForm.end_time = this.$moment(this.endDate).format('YYYY-MM-DD ') + this.endTime;
          }
        }
      }
      if (Date.parse(this.ruleForm.start_time) > Date.parse(this.ruleForm.end_time)) {
        return this.$message.error('结束日期不能小于开始日期');
      }
      if (this.ruleForm.fail_time && Date.parse(this.ruleForm.start_time) > Date.parse(this.ruleForm.fail_time)) {
        return this.$message.error('重复截至日期不能小于开始日期');
      }
      this.superiorUser.map(function (item) {
        _this2.ruleForm.member.push(item.value);
      });
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          if (_this2.ruleForm.type) {
            _this2.editFn();
          } else {
            _this2.addFn();
          }
        }
      });
    },
    daysChange: function daysChange(e) {
      this.ruleForm.days = [];
    },
    // 编辑
    editFn: function editFn() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this3.loading = true;
              _context.next = 3;
              return scheduleEditApi(_this3.id, _this3.ruleForm);
            case 3:
              result = _context.sent;
              if (!(result.status == 200)) {
                _context.next = 9;
                break;
              }
              _context.next = 7;
              return _this3.$emit('getList');
            case 7:
              _context.next = 9;
              return _this3.handleClose();
            case 9:
              _this3.loading = false;
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 新增
    addFn: function addFn() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this4.loading = true;
              _context2.next = 3;
              return scheduleStoreApi(_this4.ruleForm);
            case 3:
              result = _context2.sent;
              if (!(result.status == 200)) {
                _context2.next = 9;
                break;
              }
              _context2.next = 7;
              return _this4.$emit('getList');
            case 7:
              _context2.next = 9;
              return _this4.handleClose();
            case 9:
              _this4.loading = false;
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    openBox: function openBox(data) {
      var _this5 = this;
      this.ruleForm.days = [];
      this.getTypes();
      if (data) {
        if (data.edit) {
          this.edit = true;
          this.durationType = 5;
          this.id = data.id;
          var info = {
            start_time: data.date.start,
            end_time: data.date.end
          };
          scheduleInfoApi(data.id, info).then(function (res) {
            if (res.data.all_day == 1) {
              res.data.all_day = true;
            } else {
              res.data.all_day = false;
            }
            _this5.ruleForm.type = data.type;
            _this5.ruleForm.period = res.data.period;
            _this5.ruleForm.start = data.date.start;
            _this5.ruleForm.end = data.date.end;
            _this5.ruleForm.remind = res.data.remindInfo.ident;
            _this5.ruleForm.title = res.data.title;
            _this5.ruleForm.cid = res.data.cid;
            _this5.ruleForm.all_day = res.data.all_day;
            _this5.ruleForm.rate = res.data.rate;
            res.data.days.map(function (item) {
              _this5.ruleForm.days.push(item + '');
            });
            if (_this5.ruleForm.all_day) {
              if (data.type == 2) {
                _this5.endDate = _this5.$moment(res.data.end_time).format('yyyy-MM-DD ');
                _this5.startDate = _this5.$moment(res.data.start_time).format('yyyy-MM-DD ');
              } else {
                _this5.endDate = _this5.$moment(data.date.end).format('yyyy-MM-DD ');
                _this5.startDate = _this5.$moment(data.date.start).format('yyyy-MM-DD ');
              }
            } else {
              if (data.type == 2) {
                _this5.endTime = _this5.$moment(res.data.end_time).format('HH:mm:ss');
                _this5.endDate = _this5.$moment(res.data.end_time).format('yyyy-MM-DD ');
                _this5.startDate = _this5.$moment(res.data.start_time).format('yyyy-MM-DD ');
                _this5.startTime = _this5.$moment(res.data.start_time).format('HH:mm:ss');
              } else {
                _this5.endTime = _this5.$moment(data.date.end).format('HH:mm:ss');
                _this5.endDate = _this5.$moment(data.date.end).format('yyyy-MM-DD ');
                _this5.startDate = _this5.$moment(data.date.start).format('yyyy-MM-DD ');
                _this5.startTime = _this5.$moment(data.date.start).format('HH:mm:ss');
              }
            }
            _this5.ruleForm.member = res.data.member;
            _this5.ruleForm.content = res.data.content;
            _this5.ruleForm.fail_time = res.data.fail_time;
            _this5.cidName = res.data.type.name;
            _this5.backgroundColor = res.data.color;
            res.data.user.map(function (item) {
              item.value = item.id;
              _this5.superiorUser.push(item);
            });
          });
        } else {
          this.getUser();
          this.startDate = data.startDate;
          this.startTime = data.startTime;
          this.endDate = data.endDate;
          this.endTime = this.$moment(data.time).add(1, 'hours').format('HH:mm:ss');
          this.durationTypeFn();
        }
      } else {
        this.formatTime();
        this.durationTypeFn();
        this.getUser();
      }
      setTimeout(function () {
        var top = _this5.$refs.scrollRef;
        top.scrollTo({
          top: 0
        });
      }, 300);
      this.drawer = true;
    },
    cidChangeFn: function cidChangeFn(e) {
      var colorN = this.tableData.filter(function (item) {
        if (item.id == e) {
          return item;
        }
      });
      this.backgroundColor = colorN[0].color;
    },
    getUser: function getUser() {
      var userInfo = JSON.parse(localStorage.getItem('userInfo'));
      var list = {
        id: userInfo.id,
        value: userInfo.id,
        name: userInfo.name,
        avatar: userInfo.avatar
      };
      this.superiorUser.push(list);
    },
    allDayFn: function allDayFn(e) {
      if (this.rules.all_day) {}
    },
    handleClose: function handleClose() {
      this.drawer = false;
      this.$refs.ueditorFrom.clear();
      this.backgroundColor = '#1890FF';
      this.id = '';
      this.edit = false;
      this.superiorUser = [];
      this.ruleForm = {
        title: '',
        member: [],
        content: '',
        remind: 1,
        period: 0,
        all_day: false,
        cid: 1,
        rate: 1,
        // 重复频率
        days: [],
        start_time: '',
        end_time: '',
        fail_time: null,
        start: '',
        end: '',
        type: ''
      };
      this.ruleForm.content = '';
      this.durationType = 2;
      this.formatTime();
      this.durationTypeFn();
      this.$refs.ruleForm.resetFields();
    },
    ueditorEdit: function ueditorEdit(e) {
      this.ruleForm.content = e;
    },
    getTypes: function getTypes() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var result;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this6.tableData = [];
              _context3.next = 3;
              return scheduleTypesApi();
            case 3:
              result = _context3.sent;
              result.data.map(function (item) {
                if (item.is_public !== 0) {
                  _this6.tableData.push(item);
                }
              });
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    // 获取人员回调
    getSelectList: function getSelectList(data) {
      this.superiorUser = data;
    }
  }
};